module.exports = __webpack_public_path__ + "static/media/loginBg.c4666d22.jpg";